<template>
  <TableBodyRow
    class="gw_table_body_row_hoverable hhandsrow gw_hvr"
    :thead="thead"
    @click="$emit('click')"
  >
    <TableBodyCell
      style="--max-width-td: 4rem; --min-width-td: 4rem; --padding-td: 0; justify-content: center"
      @click.stop
    >
      <div
        class="d-flex"
        style="gap: 0.5rem"
      >
        <Checkbox
          class="csst csst_nm flgmfslctr_title_controls_item"
          style="
            --icon-size: 1.25rem;
            --clr-disabled: var(--clr-grey-2);
            --clr-enabled: var(--clr-primary);
          "
          :value="isSelected"
          @click="$emit('toggle:selected')"
        >
          <template #content>
            <div
              class="csst_content text-nowrap clr-white"
              style="line-height: 1.2; left: calc(100% + 0.5rem)"
              v-html="$t('common.select')"
            />
          </template>
        </Checkbox>
        <Checkbox
          class="csst csst_nm flgmfslctr_title_controls_item"
          style="
            --icon-size: 1.25rem;
            --clr-disabled: var(--clr-grey-2);
            --clr-enabled: var(--clr-yellow);
          "
          :icons="['mdi-star-outline', 'mdi-star']"
          :value="item.marked"
          @click="$emit('toggle:marked')"
        >
          <template #content>
            <div
              class="csst_content text-nowrap clr-white"
              style="line-height: 1.2; left: calc(100% + 0.5rem)"
              v-html="$t(`common.${item.marked ? 'starred' : 'not_starred'}`)"
            />
          </template>
        </Checkbox>
      </div>
    </TableBodyCell>
    <TableBodyCell
      v-show="thead.created_at"
      thKey="created_at"
    >
      {{ formatISODate(item.created_at) }}
    </TableBodyCell>

    <TableBodyCell
      v-show="thead.format"
      thKey="format"
    >
      <div
        v-if="item.format === 'Custom'"
        class="truncate"
      >
        Custom
      </div>
      <div v-else>
        {{ item.gameformat ? $t(`gametypes.groups.${item.gameformat.group}`) : '' }}
      </div>
    </TableBodyCell>
    <TableBodyCell
      v-show="thead.name"
      thKey="name"
    >
      <div
        class="truncate"
        :title="item.name"
      >
        {{ item.local_name }}
      </div>
    </TableBodyCell>
    <TableBodyCell
      v-show="thead.hands"
      thKey="hands"
    >
      {{ item.total_hands }}
    </TableBodyCell>
    <TableBodyCell
      v-show="thead.gto_score"
      thKey="gto_score"
    >
      <span
        v-if="!isNull(item.gto_score_avg)"
        :style="`color:${getGtoScoreGroup(item.gto_score_avg).clr}`"
      >
        {{ numFixed(item.gto_score_avg * 100, 2) }}
      </span>
    </TableBodyCell>
    <TableBodyCell
      v-show="thead.ev_loss"
      thKey="ev_loss"
    >
      <span
        v-if="!isNull(item.total_ev_loss_sum)"
        :style="`color:${getEvLossGroup(item.total_ev_loss_sum).clr}`"
      >
        {{ numFixed(item.total_ev_loss_sum, 2) }}
      </span>
    </TableBodyCell>
    <TableBodyCell
      v-show="thead.ev_loss_avg"
      thKey="ev_loss_avg"
    >
      <span
        v-if="!isNull(item.total_ev_loss_avg)"
        :style="`color:${getEvLossGroup(item.total_ev_loss_avg).clr}`"
      >
        {{ numFixed(item.total_ev_loss_avg, 2) }}
      </span>
    </TableBodyCell>
    <TableBodyCell style="order: 99; justify-content: flex-end">
      <div class="weight_500 gw_btn text-medium gw_hvr_content gw_hover_half-opacitya csst csst_nm">
        <div class="mdi mdi-chevron-double-right mr-1"></div>
        {{ $t('common.stats') }}
        <div
          class="csst_content clr-white text-nowrap"
          style="
            position: absolute;
            max-width: clamp(12rem, 36rem, 96vw);
            left: 0;
            transform: translate(calc(-100% - 2px), 0);
          "
          v-html="$t('tooltips.see_performance')"
        ></div>
      </div>
    </TableBodyCell>
  </TableBodyRow>
</template>

<script>
import Checkbox from '@/components/Common/Checkbox/Checkbox'
import TableBodyRow from '@/components/DataTables/v2/TableBodyRow'
import TableBodyCell from '@/components/DataTables/v2/TableBodyCell'
import table_mix from '@/components/DataTables/table_mix'
import format_mix from '@/mixins/format_mix'

export default {
  name: 'PracticeSessionsTableV2Row',

  components: {
    TableBodyRow,
    TableBodyCell,
    Checkbox,
  },
  mixins: [table_mix, format_mix],
  props: {
    item: Object,
    index: Number,
    thead: Object,
    isSelected: Boolean,
  },
  emits: ['click', 'toggle:selected', 'toggle:marked'],
  data() {
    return {}
  },
}
</script>
